import {Skeleton} from "@mui/material";
import {shallowEqual, useSelector} from "react-redux";
import {usersSelectors} from "@/redux/slices/users";


const UserName = ({uid}: { uid: number }) => {
    const userDetails = useSelector(state => usersSelectors.getUserDetails(state), shallowEqual);

    return <>
        {!userDetails ? <Skeleton sx={{width: "5rem"}} variant="text"/> : `${userDetails.firstName} ${userDetails.lastName}`}
    </>
}

export default UserName;